module.exports = __webpack_public_path__ + "img/yj5.db960388.png";